//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Login } from "@/utils/commonUtils";
import { passport } from "@/model/api/loginService.js";
import { phoneReg, nameReg, codeReg } from "@/utils/regular.js";
import { store, mutations } from "@/observable/store";
export default {
	data() {
		return {
			applicantPhone: "",
			applicantCode: "",
			codeClickFlag: true,
			showTime: true,
			count: "",
			timer: null,
			codeShow: true,
			captchaPending: false,
		};
	},
	props: {
		fontColor: {
			// 字体颜色
			type: String,
			default() {
				return "";
			},
		},
		isLogin: {
			// 是否静默登陆
			type: Boolean,
			default() {
				return false;
			},
		},
		isLable: {
			// 是否展示标题
			type: Boolean,
			default() {
				return false;
			},
		},
		styleType: {
			// 福袋活动得样式
			type: Boolean,
			default() {
				return false;
			},
		},
		accountRule: {
			type: Number,
			default: 0
		}
	},
	computed: {
		uid() {
			return store.uid;
		},
		loginPhone() {
			let tel = String(store.phone);
			let phone = tel.substr(0, 3) + "xxxx" + tel.substr(7);
			return phone;
		},
	},
	watch: {
		applicantCode(val) {
			// 判断手机号是否正确
			this.applicantPhone = this.applicantPhone.trim();
			let PhoneTest = phoneReg.test(this.applicantPhone);
			// 判断验证码是否位纯数字
			this.applicantCode = this.applicantCode.trim();
			let codeTest = codeReg.test(this.applicantCode);
			// 登录
			if (PhoneTest && val.length > 5 && codeTest) {
				let loginInfo = {
					applicantCode: val,
					applicantPhone: this.applicantPhone,
				};
				this.$emit("codeClick", loginInfo);
			}
		},
	},
	mounted() {
		// this.scrollInto();
	},
	methods: {
		setdata(data) {
			//用户授权书返回 设置缓存手机号
			this.applicantPhone = data.applicantPhone;
		},
		//验证码倒计时
		getCodeTime() {
			const TIME_COUNT = 60;
			if (!this.timer) {
				this.count = TIME_COUNT;
				this.showTime = false;
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--;
					} else {
						this.showTime = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}
		},
		//获取验证码
		getCode() {
			if (this.captchaPending) return;
			this.STATISTICS_CONFIG.insur_register_getcode_click();
			this.applicantPhone = this.applicantPhone.trim();
			let PhoneFlag = phoneReg.test(this.applicantPhone);
			if (!PhoneFlag) {
				this.$toast("请填写您的手机号码");
				return;
			}
			if (this.codeClickFlag) {
				this.codeClickFlag = false;
				this.captchaPending = true;
				Login.getlogin()
					.then((data) => {
						if (data && data.pass) {
							this.getCodeTime();
							let parme = {
								phone: this.applicantPhone,
								country_code: "86",
								account_rule: this.accountRule || 0,
								// challenge:data.challenge,
								// sense_id:"39972a813f8696146efb3f2261cedfa1"
							};
							passport(parme)
								.then((data) => {})
								.catch((err) => {
									this.$toast(err.message);
								});
						}
					})
					.catch((err) => {
						this.$toast(
							typeof err === "string"
								? err
								: err instanceof Error
								? err.message
								: "验证失败！"
						);
					})
					.finally(() => {
						this.codeClickFlag = true;

						this.captchaPending = false;
					});
			}
		},
		blurPhone() {
			this.scrollInto();
			if (this.applicantPhone) {
				this.STATISTICS_CONFIG.insur_register_phone_click();
			}
		},
		blurCode() {
			this.scrollInto();
			if (this.applicantCode) {
				this.STATISTICS_CONFIG.insur_register_code_click();
			}
		},
		scrollInto() {
			window.setTimeout(function() {
				const scrollHeight =
					document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollHeight) {
					window.scrollTo(0, Math.max(scrollHeight - 1, 0));
				}
			}, 0);
		},
	},
};
